/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_OrgInputs */

const cs_billing_org = /** @type {(inputs: Billing_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firemní pool`)
};

const en_billing_org = /** @type {(inputs: Billing_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization pool`)
};

/**
* | output |
* | --- |
* | "Organization pool" |
*
* @param {Billing_OrgInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_org = /** @type {((inputs?: Billing_OrgInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_OrgInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_org(inputs)
	return cs_billing_org(inputs)
});